import React from 'react';
 
const Header = () => {
   return (
       <header className="flex items-center justify-center h-12 bg-blue-700 font-cursive">
           <h1 className="text-white text-center text-lg">To Do List</h1>
       </header>
   );
};
 
export default Header;
